import { Source } from '@sodamnfoolish/sjc-backend-types/src/api/feed/dto';
import { ParserBackend, UploadMetadataArgs } from '../utils/parser-backend';
import { Api } from '@sodamnfoolish/sjc-backend-types';
import { debounceAsync } from '../utils/fn';

const parserBackend = new ParserBackend(process.env.REACT_APP_BACKEND_URL!);

const register = (accessCode: string) => {
    return parserBackend.register(accessCode, window.location.origin, window.location.origin);
};

const login = () => {
    return parserBackend.login(window.location.origin, window.location.origin);
};

const me = () => {
    return parserBackend.me();
};

const logout = () => {
    return parserBackend.logout(window.location.origin);
};

const getSources = async () => {
    const sources = await parserBackend.getSources();
    return sources;
};

const getPumpFunBubbles = async (twitterUsername?: string, size: number = 20) => {
    const bubbles = await parserBackend.getPumpFunBubbles(twitterUsername, size);
    return bubbles;
};

const getBonkBubbles = async (twitterUsername?: string, size: number = 20) => {
    const bubbles = await parserBackend.getBonkBubbles(twitterUsername, size);
    return bubbles;
};

const getFeed = async (sources: Source[], size = 20) => {
    const posts = await parserBackend.getFeed(sources, size);
    return posts;
};

const getMedia = async (id: string) => {
    const media = await parserBackend.getMedia(id);
    return media;
};

// eslint-disable-next-line react-hooks/exhaustive-deps
const getTwitterUserInfoByUsername = debounceAsync(parserBackend.getTwitterUserInfoByUsername);

const getChatGptMetadataFromPostId = async (postId: string) => {
    const chatGptMetadata = await parserBackend.getChatGptMetadataFromPostId(postId);
    return chatGptMetadata;
};

const generateTokenMetadataByTweetUrl = async (tweetUrl: string) => {
    const tokenMetadata = await parserBackend.generateTokenMetadataByTweetUrl(encodeURIComponent(tweetUrl));
    return tokenMetadata;
};

const generateTokenMetadataByUrl = async (url: string) => {
    const tokenMetadata = await parserBackend.generateTokenMetadataByUrl(encodeURIComponent(url));
    return tokenMetadata;
};

const generateImage = (generateImageRequest: Api.AI.DTO.GenerateImageRequest) => {
    return parserBackend.generateImage(generateImageRequest);
};

const getTokenMetadata = async (mint: string) => {
    const tokenMetadata = await parserBackend.getTokenMetadata(mint);
    return tokenMetadata;
};

const deployWithSnipe = async (snipeRequest: Api.Wallet.DTO.DeployWithSniperRequest) => {
    const response = await parserBackend.deployWithSnipe(snipeRequest);
    return response;
};

const uploadMetadata = async (args: UploadMetadataArgs) => {
    const response = await parserBackend.uploadMetadata(args);
    return response;
};

export const useBackend = () => {
    return {
        register,
        login,
        me,
        logout,
        getSources,
        getPumpFunBubbles,
        getBonkBubbles,
        getFeed,
        getTwitterUserInfoByUsername,
        getMedia,
        getChatGptMetadataFromPostId,
        generateTokenMetadataByTweetUrl,
        generateTokenMetadataByUrl,
        generateImage,
        getTokenMetadata,
        deployWithSnipe,
        uploadMetadata,
    };
};
